const App = {
  setup() {
    let topSSS = 0;
    let rect = '';
    let scrollY = 0;
    onMounted(() => {
      window.addEventListener("load", function(){
        rect  = document.getElementsByClassName('chose-list-options')[0].getBoundingClientRect()
        scrollY = window.scrollY || document.documentElement.scrollTop;
        topSSS  = rect.top+scrollY > topSSS ? rect.top+scrollY : topSSS
      })
    })
    onUnmounted(() => {
      window.removeEventListener("load", function(){
        rect  = document.getElementsByClassName('chose-list-options')[0].getBoundingClientRect()
        topSSS  = rect.top
      });
    })
    const pageLengthList = ref([16,28,48]);
    const sortByList = ref([
      {key: 4, label: "Recommended"},
      {key: 1, label: "New Products"},
      {key: 2, label: "Price High to Low"},
      {key: 3, label: "Price Low to High"},
    ]);
    const drawerState = reactive({
      filter: false,
      sortBy: false,
      size: 0,
    });
    const videoDialog = reactive({
      showState: false,
      videoSrc: "",
      size: 0,
    });
    const pageParams = reactive({
      collection_id: CollectionId,
      filter_category_id: 0,
      filter: [],
      vendor: [],
      activity: [],
      page: 1,
      pageSize: 16,
      sortBy: 4,
      priceRange: [0, 0],
      priceRangeFirst: [0, 0],
      ep_id: 0,
    });
    const goPageNumber = ref('');
    const selectFilter = reactive([]);
    const priceRange = ref([]);
    const priceRangeFirst = ref([]);
    const selectedItem = ref([]);
    const selectedCount = reactive({
      filter: {},
      vendor: {},
    });
    const vendorData = ref([]);
    const first_request = ref(0);
    const productData = reactive({
      showStyle: 1,
      total: 0,
      list: [],
      loading: false,
    });
    const filterData = ref([]);
    const categoryData = reactive({});
    const activityData = reactive({list: []});
    const localMenuData = ref([]);
    const activeIndex = ref(null);

  const activeIndexes = ref([]); // 存储多个展开的索引
  const selectedCategory = ref(null);

  const toggleCategory = (index) => {
    if (activeIndexes.value.includes(index)) {
      // 如果已展开，则收起
      activeIndexes.value = activeIndexes.value.filter(i => i !== index);
    } else {
      // 否则添加到展开列表
      activeIndexes.value.push(index);
    }
  };


  const loadList = (event, categoryId) => {
      event.stopPropagation();
      selectedCategory.value = categoryId;
      first_request.value = 1
      getList(getDefaultVehicle(), categoryId, localMenuData.value, 'pc');
  }
    const choicePrice = (minPrice, maxPrice) => {
      pageParams.priceRange[0] = minPrice;
      pageParams.priceRange[1] = maxPrice;
      priceRangeFirst.value[0] = minPrice;
      priceRangeFirst.value[1] = maxPrice;
      if (maxPrice === 0) {
        priceRangeFirst.value[1] = "";
      }
    };

    const choiceVariants = (variantId, productIndex) => {
      productData.list[productIndex]["default"] = productData.list[productIndex]["variants"].find(
        (item) => item["variant_id"] === variantId
      );
    };
    const params = reactive({
      filter: [],
      vendor: [],
      price_range: {
        min: 0,
        max: 0,
      },
      is_new: 1,
      category_id: null
    });
    const isUrlFromSearch = ref(false);
    const YMM = getDefaultVehicle()
    const urlRequestParams = ref('');
    const formatParams = (vehicle) => {
      if(pageParams.activity.length === 0 && requestParams.is_activity)
      {
        pageParams.activity.push(requestParams.is_activity);
        selectFilter.push({'id':1, 'options':'activity', 'name':'Clearance Event Products', 'type':'activity'})
        requestParams.is_activity = 1
      }

      let year  = requestParams.year  ? requestParams.year  : YMM.year;
      let make  = requestParams.make  ? requestParams.make  : YMM.make;
      let model = requestParams.model ? requestParams.model : YMM.model;
      let is_activity = pageParams.activity[0] ? pageParams.activity[0] : 0;
      if(year || make || model) {
        isUrlFromSearch.value = true;
        urlRequestParams.value = '?year='+year+'&make='+make+'&model='+model;
      }
      params.first_request = first_request.value;
      params.page = pageParams.page;
      params.page_size = pageParams.pageSize;
      params.sortBy = pageParams.sortBy;
      params.price_range["min"] = pageParams.priceRange[0];
      params.price_range["max"] = pageParams.priceRange[1];
      //params.filter_category_id = pageParams.filter_category_id;
      params.collection_id = pageParams.collection_id;
      params.is_activity = 1;

      params.filter = JSON.parse(JSON.stringify(pageParams.filter));
      params.vendor = JSON.parse(JSON.stringify(pageParams.vendor));

      if (vehicle) {
        params.year = vehicle.year;
        params.make = vehicle.make;
        params.model = vehicle.model;
      } else {
        params.year = requestParams.year ? requestParams.year : YMM.year;
        params.make = requestParams.make ? requestParams.make : YMM.make;
        params.model = requestParams.model ? requestParams.model : YMM.model;
      }

      if(pageParams.ep_id) {
        params.ep_id = pageParams.ep_id
      }else {
        // if(isUrlFromSearch.value)
        // {
        //   params.ep_id = window.localStorage.getItem('associativeEpidCookie');
        // }
        // else if (myGarageLocal.value.length > 0)
        // {
        //   params.ep_id = myGarageLocal.value[0]['epid'];
        // }
        // else
        // {
        //   params.ep_id = '';
        // }
      }
    };
    window.restFilter = (epid) => {
      pageParams.priceRange = [];
      pageParams.filter = [];
      pageParams.vendor = [];
      pageParams.ep_id = epid;
      selectedCount.filter = [];
      selectedCount.vendor = [];
      first_request.value = 1;
    };
    const isShowButton = ref(true);
    const showAllCategories = ref(true);
    const getList = (vehicle, categoryId, menuData, client) => {
      localMenuData.value = menuData;
      formatParams(vehicle);
      productData.loading = true;
      // fullscreenLoading.show()
      params.category_id =  categoryId || params.category_id  || pageParams.filter_category_id || 0; // 使用传入的categoryId或当前的filter_category_id
      if (isMobile()) {
          selectedCategory.value = categoryId;
         params.first_request = 1
      } else {
         if (client === 'pc') {
          selectedCategory.value = categoryId;
          first_request.value = 1;
          // pageParams.filter_category_id = categoryId || params.category_id  || pageParams.filter_category_id || 0; ;
          params.category_id = categoryId || params.category_id  || pageParams.filter_category_id || 0; ;
          params.first_request = 1
          // params.vendor = [];
        } else {
          selectedCategory.value = null;
          params.category_id =  null;
          first_request.value = 0
        }
      }
      axios({
        method: "post",
        url: API_HOST+"/products/list",
        data: params, // 传递参数
        // withCredentials: true,
      })
        .then((result) => {
          productData.total = result.data["total"];
          productData.list = result.data["products"];
          showAllCategories.value = result.data["category_list"].length <= 8

          if(isMobile())
          {
            isShowButton.value = result.data["category_list"].length > 12
          }
          else
          {
            isShowButton.value = result.data["category_list"].length > 16
          }

          //判断是否为brands顶级
          if(result.data["is_brand"])
          {
            $('#vehicle-container .vehicle-container .vehicle-title').text('Shop '+result.data["category_name"]+' Products By Vehicle');
          }

          if (result.data["filter"].length > 0)
          {
            if(result.data["filter"].length === 1 && result.data["filter"][0].length === 1)
            {
              filterData.value  = [];
            }
            else
            {
              filterData.value = result.data["filter"];
            }
          }
          // if (result.data["vendor"].length > 1 || (result.data["vendor"].length > 0 && (params['collection_id'] === 298995712165 || params['collection_id'] === 298995712165)))
          // {
            vendorData.value = result.data["vendor"] || [];
          // }

          if (result.data["category_list"].length > 0) {
            categoryData.category_list = result.data["category_list"];
          }

          if (result.data["product_type"].length > 0)
          {
            categoryData.product_type = result.data["product_type"];
          }
          // if (result.data["activity"].length > 0)
          // {
          //   activityData.list = result.data["activity"];
          // } else {
          //     activityData.list = menuData;
          // }
          if (menuData && menuData.length> 0) {
              activityData.list = menuData;
          } else {
              activityData.list = []
          }

          if (result.data["price_range"])
          {
            priceRange.value[0] = result.data["price_range"]["min"];
            priceRange.value[1] = result.data["price_range"]["max"];
          }

          if(params.page > 1)
          {
            $("html,body").animate({
              scrollTop: topSSS - (isMobile() ? 105 : 145)
            }, 500);
          }
          first_request.value = 0;
          // fullscreenLoading.hide()
        })
        .catch((error) => {
          console.error(error);
          fullscreenLoading.hide()
        }).finally(() => {
          productData.loading = false;
        }
      );
    };
    //选中/取消 筛选项
    const operateFilterItem = (setItem) => {
      let addNewFilter = true;

      for(let key = 0; key < selectFilter.length; key++)
      {
        let selectTmp = selectFilter[key];

        if(selectTmp.type !== setItem.type || selectTmp.options !== setItem.options)
        {
          continue;
        }

        if(selectTmp.id === setItem.id)
        {
          addNewFilter = false;
          selectFilter.splice(key, 1);
        }

        if(!setItem.multiple && addNewFilter === true)
        {
          selectFilter.splice(key, 1);
        }
      }

      if(addNewFilter)
      {
        selectFilter.push(setItem)
      }

      let tmpData = [];
      selectFilter.map((data) => {
        if (data.type === setItem.type) {
          tmpData.push(data.id);
        }
      });
      first_request.value = 1;
      pageParams[setItem['type']] = JSON.parse(JSON.stringify(tmpData));
    };
    const operateFilterCategoryItem = (categoryId) => {
      pageParams.filter_category_id = categoryId;
      window.restFilter();
      first_request.value = 1;
    }
    const checkItemSelect = (itemType, itemId) => {
      let selectData  = selectFilter['filter'][itemType] ?? null;

      if(!selectData)
      {
        return false;
      }

      return (selectData.constructor === Array && selectData.indexOf(itemId) > -1) || selectData === itemId;
    }
     watch(
      pageParams,
      () => {
        getList(getDefaultVehicle(), selectedCategory.value, localMenuData.value, 'pc');
      },
      {deep: true}
    );
    const choiceCategory = (data) => {
      pageParams.filter_category_id = data.category_id;
      window.restFilter();
      first_request.value = 1;
    };

    const showVideo = (videoSrc) => {
      if (videoSrc === '') {
        return;
      }
      videoDialog.videoSrc = videoSrc;
      videoDialog.showState = true;
      if (document.documentElement.clientWidth <= 600) {
        videoDialog.size = '80%';
      } else {
        videoDialog.size = '50%';
      }
    };

    const setDrawerSize = () => {
      if (document.documentElement.clientWidth <= 600) {
        drawerState.size = '80%';
      } else {
        drawerState.size = '50%';
      }
    }

    const getClassBasedOnValue = (num) => {
      if(isMobile())
      {
        if(num <= 3)
        {
          return 'top-menu-list-8'
        }
        else
        {
          return 'top-menu-list-none'
        }
      }
      else
      {
        if(num <= 8)
        {
          return 'top-menu-list-8'
        }
        else
        {
          return 'top-menu-list-none'
        }
      }
    }
    const getVendorStyleBasedOnValue = (vendorName) => {
      if(vendorName == 'AVS')
      {
        return 'verticalAlign';
      }
      else
      {
        return '';
      }
    }
    const toggleRowsCategories = () => {
      showAllCategories.value = !showAllCategories.value;
    }
    // 计算属性来检查当前是否是移动端
    const isMobile = ()=> {
      // 使用正则表达式来匹配常见的移动端用户代理
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    // 方法来根据索引和设备类型返回是否应该显示列表项
    const isItemVisible = (index) => {
      if (isMobile()) {
        return showAllCategories.value || index < 12;
      }
      // 否则，如果启用了显示所有类别或索引小于8，则显示
      return showAllCategories.value || index < 16;
    };
    const isShowSeeMoreAndLess = () => {
      return isShowButton.value;
    }
    const goToPage = () => {
      let goNumber = parseInt(goPageNumber.value);

      let maxPage = Math.ceil(productData.total/pageParams.pageSize);
      if(goNumber < 1 || isNaN(goNumber))
      {
        goNumber = 1;
      }
      else if(goNumber > maxPage)
      {
        goNumber = maxPage;
      }

      pageParams.page = goNumber;
    }
    return {
      goToPage,
      goPageNumber,
      checkItemSelect,
      selectFilter,
      setDrawerSize,
      showVideo,
      videoDialog,
      productData,
      categoryData,
      activityData,
      filterData,
      pageParams,
      operateFilterItem,
      selectedItem,
      vendorData,
      first_request,
      choiceVariants,
      priceRange,
      choicePrice,
      priceRangeFirst,
      choiceCategory,
      drawerState,
      loadList,
      selectedCount,
      sortByList,
      isUrlFromSearch,
      urlRequestParams,
      pageLengthList,
      restFilter,
      getClassBasedOnValue,
      getVendorStyleBasedOnValue,
      showAllCategories,
      toggleRowsCategories,
      isItemVisible,
      isShowSeeMoreAndLess,
      getList,
      activeIndex,
      selectedCategory,
      toggleCategory,activeIndexes
      // AutoSelectYmm
    };
  },
};
var paramsObject = {};
window['Sale'] = Vue.createApp(App).use(ElementPlus).mount("#list-page");
window.Pages['Sale'] = {
  getList: async function(params, categoryId) {
    const loadingText = document.querySelectorAll('.loading-text');
      try {
          const menuData = await fetchMenuData();
          if (menuData) {
              renderMainMenu(menuData);
          } else {
            loadingText.forEach((item) => {
              item.textContent = 'No menu data available';
            })
            renderMainMenu([]);
          }
      } catch (error) {
        loadingText.textContent = 'Failed to initialize the menu system';
          console.error('Failed to initialize the menu system:', error);
      }
  }
}
function contractFilter(thisObj) {
  let content = thisObj.next();
  let contentHeight = content.height();
  let arrow = thisObj.find(".filter-item-arrow");

  if (contentHeight > 0) {
    content.animate({height: "0px",marginBottom: "0px"}, 200);
    arrow.css("animation", "rotateArrow 0.2s forwards");
    thisObj.css('background','#cbcbcb');
  } else {
    content.animate({height: content.get(0).scrollHeight}, 300, function () {
      content.css("height", "auto");
      content.css("margin-bottom", "10px");
    });
    arrow.css("animation", "rotateArrowBack 0.2s forwards");
    thisObj.css('background','#e3e3e3');
  }
}
document.addEventListener('DOMContentLoaded', function() {
  window.Pages['Sale'].getList();
});
// Initialize the menu system
// Fetch menu data from API
async function fetchMenuData() {
try {
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    let hasUrlParams = urlParams.toString().length > 0;

    // If URL has parameters, store them in localStorage
    if (hasUrlParams) {
        localStorage.setItem('vehicleSearchParams', JSON.stringify(Object.fromEntries(urlParams)));
    } else {
        // If no URL parameters, check localStorage
        const storedParams = localStorage.getItem('vehicleSearchParams');
        if (storedParams) {
            const parsedParams = JSON.parse(storedParams);
            urlParams.set('year', parsedParams.year);
            urlParams.set('make', parsedParams.make);
            urlParams.set('model', parsedParams.model);
        }
    }

    // Construct API request URL
    let apiUrl = 'https://api.caautoparts.com/activity/springClearance';
    if (urlParams.toString()) {
        apiUrl += `?${urlParams.toString()}`;
    }

    // Fetch data from API
    let response = await fetch(apiUrl);
    let data = await response.json();

    // Check if data is valid
    if (data.code === 200 && data.result.length > 0) {
        paramsObject = urlParams.toString() ? Object.fromEntries(urlParams) : null; // Ensure null if no params
        return data.result;
    } else {
        console.error('API returned no valid data');
        return null;
    }
} catch (error) {
    console.error('Failed to fetch data:', error);
    return null;
}
}
// Render the main menu
function renderMainMenu(menuData) {
let wrapper = document.querySelector('.swiper-warper-parent');
wrapper.innerHTML = ''; // Clear previous data
menuData.forEach(item => {
  if (item.category_name !== 'Brands') {
    let slide = createMainMenuSlide(item);
    wrapper.appendChild(slide);
  }
});
// Initialize Swiper
initializeMainSwiper(menuData);
}
// Create main menu slides
function createMainMenuSlide(item) {
  let slide = document.createElement('div');
  slide.className = 'swiper-slide';
  slide.textContent = item.category_name;
  slide.dataset.categoryId = item.category_id;
  slide.dataset.children = JSON.stringify(item.children); // Store submenu data directly
  return slide;
}
// Initialize Swiper for the main menu
function initializeMainSwiper(menuData) {
  if (window.SwiperNav) {
      window.SwiperNav.destroy(true, true);
      window.SwiperNav = null;
  }
  window.SwiperNav = new Swiper(".Swiper-nav-wrap", {
      slidesPerView: 3,
      centeredSlides: true,
      loop: true,
      breakpoints: {
          320: { slidesPerView: 3 },
          480: { slidesPerView: 3 },
          768: { slidesPerView: 3 },
      },
      on: {
        slideChangeTransitionEnd: function (swiper) {
          if (swiper.slides && swiper.slides.length > 0) {
            let activeSlide = swiper.slides[swiper.activeIndex];
            let categoryId = activeSlide.dataset.categoryId;
            let children = JSON.parse(activeSlide.dataset.children);
            window.isSubmenuSwiperInit = true;
            if (children && children.length > 0) {
                renderSubSaleMenu(children, menuData); // Render the submenu
            } else {
                renderSubSaleMenu([], []); // No submenu available
            }
          }
        }
      }
  });
  if (menuData.length > 0) {
      renderSubSaleMenu(menuData[0].children, menuData, true); // Render the first submenu by default
  } else {
    renderSubSaleMenu([], []);
  }
}
function renderSubSaleMenu(subMenuData, menuData) {
  let wrapper = document.querySelector('.swiper-wrapper-child');
  if (window.submenuSwiper) {
      window.submenuSwiper.destroy(true, true);
      window.submenuSwiper = null;
  }

  let copiedData = JSON.parse(JSON.stringify(subMenuData));
  let originalLength = copiedData.length;

  if (copiedData.length < 4) {
      wrapper.innerHTML = copiedData.map(item => `
        <div class="swiper-slide swiper-slide-child" data-category-id="${item.category_id}">
            ${item.category_name}
        </div>
      `).join('');
  } else {
      if (originalLength > 0 && originalLength < 7) {
          let i = 0;
          while (copiedData.length < 15) {
              copiedData.push(copiedData[i % originalLength]);
              i++;
          }
      }
      wrapper.innerHTML = copiedData.map(item => `
        <div class="swiper-slide swiper-slide-child" data-category-id="${item.category_id}">
            ${item.category_name}
        </div>
      `).join('');
  }

  let middleIndex = Math.floor(copiedData.length / 2);



  window.submenuSwiper = new Swiper(".Swiper-nav-child", {
      direction: "vertical",
      slidesPerView: 7,
      loop: true,
      centeredSlides: true,
      spaceBetween: 0,
      on: {
          slideChangeTransitionEnd: function (swiper) {
              if (window.isSubmenuSwiperInit) {
                  window.isSubmenuSwiperInit = false;
                  return;
              }
              if (swiper.slides && swiper.slides.length > 0) {
                  let activeSlide = swiper.slides[swiper.activeIndex];
                  let categoryId = activeSlide.dataset.categoryId;

                  if (window.saleRequest) {
                      clearTimeout(window.saleRequest);
                  }
                  window.saleRequest = setTimeout(() => {
                      console.log("Slide changed, fetching data...");
                      window['Sale'].getList(paramsObject, categoryId);
                  }, 200);
              }
          },
      }
  });

  if (originalLength > 0) {
      let middleCategoryId = copiedData[0].category_id;
      window['Sale'].getList(paramsObject, middleCategoryId, menuData.filter(item => item.category_name !== 'Brands'));
  } else {
      window['Sale'].getList(paramsObject, null, []);
  }
}
